import { Card, CardContent, CardHeader, Divider, makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import TestsComponent from 'src/components/TestsComponent'
import { getTestCriterias } from 'src/store/actions/testActions'
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import { connect } from 'react-redux';
import ErrorMessage from 'src/components/ErrorMessage'
import { useTranslation } from 'react-i18next'


const useStyles = makeStyles((theme) => ({
    root: {
        padding: 0
    },
    dividerYorum: {
        backgroundColor: '#1D3343'
    },
    fieldsComboYorum: {
        margin: theme.spacing(0),
        display: 'flex',
    },
    content: {
        minHeight: 160,
        padding: '0px'
    },
    submitButtonComment: {
        marginTop: theme.spacing(2),
        width: '100%'
    },
}));

const Tests = ({
    className, ReceiptNo, readonly, tasks
}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const isOnline = useSelector((state) => state.status?.isOnline)
    const { t } = useTranslation('work_order');

    const { testCriterias, loading } = useSelector((state) => state.testReducer)

    useEffect(() => {
        dispatch(getTestCriterias())
    }, [])

    return (
        <Card
            className={clsx(classes.root, className)}
        >
            <CardHeader title={'Tests'} />
            <Divider />
            <CardContent className={classes.content}>
                {!isOnline ? <ErrorMessage message={t('Offline_Message')} /> : testCriterias && testCriterias.length > 0 && <TestsComponent ReceiptNo={ReceiptNo} readonly={readonly} testCriterias={testCriterias} />
                }
            </CardContent>
        </Card>
    )
}


export default connect(
    (state) => ({
        tasks: state.tasks1
    })
)(Tests);
